<div class="validar-wallet">

  <!-- Encabezado -->
  <div class="vw-header">
    <h2 class="vw-title">Validar wallet</h2>
    <p class="vw-subtitle">
      Consulta el riesgo de una direcci&oacute;n en Chainalysis y revisa las decisiones que ya tom&oacute; el sistema.
    </p>
  </div>

  <!-- ── Consulta puntual ───────────────────────────────────────── -->
  <section class="vw-card">
    <div class="vw-card-head">
      <mat-icon class="vw-card-icon">travel_explore</mat-icon>
      <div>
        <h3 class="vw-card-title">Consultar una direcci&oacute;n</h3>
        <p class="vw-card-note">Cada consulta se factura. Se ejecuta solo al presionar el bot&oacute;n.</p>
      </div>
    </div>

    <div class="vw-search">
      <input
        id="vw-direccion"
        type="text"
        class="vw-input vw-mono"
        placeholder="Pega la direcci&oacute;n (TRC20, ERC20 o BEP20)"
        [(ngModel)]="direccion"
        (keyup.enter)="consultar()"
        [disabled]="consultando" />
      <div class="vw-search-actions">
        <button type="button" class="vw-btn vw-btn-primary"
          [disabled]="!direccion.trim() || consultando"
          (click)="consultar()">
          <mat-spinner *ngIf="consultando" diameter="16"></mat-spinner>
          <span>{{ consultando ? 'Consultando...' : 'Consultar' }}</span>
        </button>
        <button type="button" class="vw-btn vw-btn-ghost"
          *ngIf="resultado || errorConsulta"
          (click)="limpiarConsulta()">Limpiar</button>
      </div>
    </div>

    <div *ngIf="errorConsulta" class="vw-alert vw-alert-error">
      <mat-icon class="vw-alert-icon">error</mat-icon>
      <span>{{ errorConsulta }}</span>
    </div>

    <!-- Resultado -->
    <div *ngIf="resultado" class="vw-result">
      <div class="vw-result-top">
        <span class="vw-chip vw-chip-lg"
          [style.background]="colorRiesgo(resultado.risk).fondo"
          [style.color]="colorRiesgo(resultado.risk).texto">
          {{ resultado.risk || 'Sin nivel' }}
        </span>
        <span class="vw-mono vw-break">{{ resultado.address }}</span>
      </div>

      <dl class="vw-defs">
        <div class="vw-def">
          <dt>Motivo</dt>
          <dd>{{ resultado.riskReason || 'Sin motivo informado' }}</dd>
        </div>
        <div class="vw-def">
          <dt>Tipo</dt>
          <dd>{{ resultado.addressType || '—' }}</dd>
        </div>
        <div class="vw-def">
          <dt>Entidad</dt>
          <dd>
            {{ resultado.cluster?.name || '—' }}
            <span *ngIf="resultado.cluster?.category" class="vw-muted">
              ({{ resultado.cluster.category }})
            </span>
          </dd>
        </div>
        <div class="vw-def">
          <dt>Estado</dt>
          <dd>{{ resultado.status || '—' }}</dd>
        </div>
      </dl>

      <!-- Exposiciones: lo que explica el nivel -->
      <div *ngIf="exposicionesOrdenadas.length" class="vw-sub">
        <h4 class="vw-sub-title">Exposiciones</h4>
        <ul class="vw-list">
          <li *ngFor="let exp of exposicionesOrdenadas">
            <span>{{ exp.category }}</span>
            <span class="vw-mono">{{ exp.value | number: '1.0-2' }}</span>
          </li>
        </ul>
      </div>

      <div *ngIf="resultado.triggers?.length" class="vw-sub">
        <h4 class="vw-sub-title">Reglas activadas</h4>
        <ul class="vw-list">
          <li *ngFor="let trg of resultado.triggers">
            <span>{{ trg.category || trg.ruleId || 'Regla' }}</span>
            <span class="vw-mono" *ngIf="trg.percentage != null">{{ trg.percentage }}%</span>
          </li>
        </ul>
      </div>
    </div>
  </section>

  <!-- ── Historial ──────────────────────────────────────────────── -->
  <section class="vw-card">
    <div class="vw-card-head">
      <mat-icon class="vw-card-icon">history</mat-icon>
      <div>
        <h3 class="vw-card-title">Historial de decisiones</h3>
        <p class="vw-card-note">Lee lo ya guardado. No consulta a Chainalysis.</p>
      </div>
    </div>

    <!-- Filtros -->
    <div class="vw-filters">
      <div class="vw-field">
        <label for="vw-f-wallet">Wallet</label>
        <input id="vw-f-wallet" type="text" class="vw-input vw-mono"
          placeholder="Direcci&oacute;n exacta" [(ngModel)]="filtroWallet"
          (keyup.enter)="buscarHistorial(1)" />
      </div>
      <div class="vw-field">
        <label for="vw-f-user">Usuario</label>
        <input id="vw-f-user" type="text" inputmode="numeric" class="vw-input"
          placeholder="ID" [(ngModel)]="filtroUserId"
          (keyup.enter)="buscarHistorial(1)" />
      </div>
      <div class="vw-field">
        <label for="vw-f-decision">Decisi&oacute;n</label>
        <select id="vw-f-decision" class="vw-input" [(ngModel)]="filtroDecision">
          <option value="">Todas</option>
          <option *ngFor="let d of decisiones" [value]="d">{{ d }}</option>
        </select>
      </div>
      <div class="vw-field">
        <label for="vw-f-contexto">Contexto</label>
        <select id="vw-f-contexto" class="vw-input" [(ngModel)]="filtroContexto">
          <option value="">Todos</option>
          <option *ngFor="let c of contextos" [value]="c">{{ c }}</option>
        </select>
      </div>
      <div class="vw-field vw-field-actions">
        <button type="button" class="vw-btn vw-btn-primary"
          [disabled]="cargandoHistorial" (click)="buscarHistorial(1)">Buscar</button>
        <button type="button" class="vw-btn vw-btn-ghost"
          [disabled]="cargandoHistorial" (click)="limpiarFiltros()">Limpiar</button>
        <button type="button" class="vw-btn vw-btn-ghost"
          [disabled]="cargandoHistorial || exportando || !registros.length"
          (click)="exportarExcel()">
          <mat-spinner *ngIf="exportando" diameter="15"></mat-spinner>
          <mat-icon *ngIf="!exportando" class="vw-btn-icon">download</mat-icon>
          <span>{{ exportando ? 'Generando...' : 'Excel' }}</span>
        </button>
      </div>
    </div>

    <div *ngIf="errorExport" class="vw-alert vw-alert-warn">
      <mat-icon class="vw-alert-icon">info</mat-icon>
      <span>{{ errorExport }}</span>
    </div>

    <div *ngIf="errorHistorial" class="vw-alert vw-alert-error">
      <mat-icon class="vw-alert-icon">error</mat-icon>
      <span>{{ errorHistorial }}</span>
    </div>

    <div *ngIf="cargandoHistorial" class="vw-loading">
      <mat-spinner diameter="22"></mat-spinner>
      <span>Cargando historial...</span>
    </div>

    <div *ngIf="!cargandoHistorial && !registros.length && !errorHistorial" class="vw-empty">
      No hay decisiones registradas con esos filtros.
    </div>

    <!-- Tabla: pantallas anchas -->
    <div class="vw-table-wrap" *ngIf="!cargandoHistorial && registros.length">
      <table class="vw-table">
        <thead>
          <tr>
            <th>Fecha</th>
            <th>Usuario</th>
            <th>Wallet</th>
            <th>Red</th>
            <th>Contexto</th>
            <th>Riesgo</th>
            <th>Decisi&oacute;n</th>
            <th>Motivo</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let r of registros">
            <td class="vw-nowrap">{{ formatearFecha(r.createdAt) }}</td>
            <td class="vw-mono">{{ r.userId }}</td>
            <td class="vw-mono" [title]="r.walletAddress">{{ acortarWallet(r.walletAddress) }}</td>
            <td>{{ r.network }}</td>
            <td>{{ r.contexto }}</td>
            <td>
              <span class="vw-chip"
                [style.background]="colorRiesgo(r.risk).fondo"
                [style.color]="colorRiesgo(r.risk).texto">{{ r.risk || '—' }}</span>
            </td>
            <td>
              <span class="vw-chip"
                [style.background]="colorDecision(r.decision).fondo"
                [style.color]="colorDecision(r.decision).texto">{{ r.decision }}</span>
              <span *ngIf="r.desdeCache" class="vw-cache" title="Resuelto con un resultado previo">cach&eacute;</span>
            </td>
            <td class="vw-reason">{{ r.riskReason || r.error || r.clusterCategory || '—' }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Tarjetas: tel&eacute;fono -->
    <div class="vw-cards" *ngIf="!cargandoHistorial && registros.length">
      <article class="vw-mini" *ngFor="let r of registros">
        <div class="vw-mini-top">
          <span class="vw-chip"
            [style.background]="colorDecision(r.decision).fondo"
            [style.color]="colorDecision(r.decision).texto">{{ r.decision }}</span>
          <span class="vw-chip"
            [style.background]="colorRiesgo(r.risk).fondo"
            [style.color]="colorRiesgo(r.risk).texto">{{ r.risk || '—' }}</span>
        </div>
        <p class="vw-mono vw-break vw-mini-wallet">{{ r.walletAddress }}</p>
        <div class="vw-mini-meta">
          <span>{{ r.contexto }}</span>
          <span>{{ r.network }}</span>
          <span>Usuario {{ r.userId }}</span>
        </div>
        <p class="vw-mini-reason" *ngIf="r.riskReason || r.error">
          {{ r.riskReason || r.error }}
        </p>
        <p class="vw-mini-date">{{ formatearFecha(r.createdAt) }}</p>
      </article>
    </div>

    <!-- Paginaci&oacute;n -->
    <div class="vw-pager" *ngIf="!cargandoHistorial && totalPages > 1">
      <button type="button" class="vw-page" [disabled]="page <= 1"
        (click)="buscarHistorial(page - 1)">Anterior</button>
      <button type="button" class="vw-page" *ngFor="let p of paginasVisibles"
        [class.is-active]="p === page" (click)="buscarHistorial(p)">{{ p }}</button>
      <button type="button" class="vw-page" [disabled]="page >= totalPages"
        (click)="buscarHistorial(page + 1)">Siguiente</button>
    </div>

    <p class="vw-total" *ngIf="!cargandoHistorial && total">
      {{ total }} decisi{{ total === 1 ? '&oacute;n' : 'ones' }} registrada{{ total === 1 ? '' : 's' }}
    </p>
  </section>
</div>
